import bowser from 'bowser';

var STOPPLE_ID = "bad-browser-stopple";
var IGNORE_KEY = "fau_ignore_browser_check";

if (![].includes) {
  Array.prototype.includes = function(searchElement/*, fromIndex*/) {
    'use strict';
    var O = Object(this);
    var len = parseInt(O.length) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1]) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    while (k < len) {
      var currentElement = O[k];
      if (searchElement === currentElement ||
         (searchElement !== searchElement && currentElement !== currentElement)
      ) {
        return true;
      }
      k++;
    }
    return false;
  };
}

if (!Array.from) {
  Array.from = (function() {
    var toStr = Object.prototype.toString;
    var isCallable = function(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // Свойство length метода from равно 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Положим C равным значению this.
      var C = this;

      // 2. Положим items равным ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. Если mapfn равен undefined, положим mapping равным false.
      var mapFn = arguments[1];
      if (typeof mapFn !== 'undefined') {
        mapFn = arguments.length > 1 ? arguments[1] : void undefined;
        // 5. иначе
        // 5. a. Если вызов IsCallable(mapfn) равен false, выкидываем исключение TypeError.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. Если thisArg присутствует, положим T равным thisArg; иначе положим T равным undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Положим lenValue равным Get(items, "length").
      // 11. Положим len равным ToLength(lenValue).
      var len = toLength(items.length);

      // 13. Если IsConstructor(C) равен true, то
      // 13. a. Положим A равным результату вызова внутреннего метода [[Construct]]
      //     объекта C со списком аргументов, содержащим единственный элемент len.
      // 14. a. Иначе, положим A равным ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Положим k равным 0.
      var k = 0;
      // 17. Пока k < len, будем повторять... (шаги с a по h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Положим putStatus равным Put(A, "length", len, true).
      A.length = len;
      // 20. Вернём A.
      return A;
    };
  }());
}

if (!Object.assign) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(target, firstSource) {
      'use strict';
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object');
      }

      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) {
          continue;
        }

        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
      return to;
    }
  });
}

Number.isEqual = (x, y, precision) => {
  var e = Math.pow(10, precision);
  return Math.round(x * e) == Math.round(y * e);
}

Number.toPrettyString = (x, precision) => {
  var v = Math.pow(10, precision);
  return "" + (Math.round(x * v) / v);
}


if (checkBrowser()) {
  execApp();
} else {
  createStopple();
}

window.doExecApp = function() {
  sessionStorage.setItem(IGNORE_KEY, "1");
  execApp();
}

function execApp() {
  removeStopple();
  var script = document.createElement("script");
  script.setAttribute("src", "/app.js?" + process.env.UNIQUE);
  document.body.appendChild(script);
}

function checkBrowser() {
  if (sessionStorage.getItem(IGNORE_KEY) === "1") {
    return true;
  }

  const browser = bowser.getParser(window.navigator.userAgent);
  return browser.satisfies({
    msie: ">=12",
    msedge: ">=14",
    chrome: ">=49",
    firefox: ">=45",
    safari: ">=8",
    opera: ">=20"
  });
}

function makeBrowsersList(data) {
  var ul = document.createElement("ul");
  for (var i = 0; i < data.length; ++i) {
    var a = document.createElement("a");
    a.setAttribute("href", data[i][1]);
    a.setAttribute("target", "_blank");
    a.innerHTML = data[i][0];
    var li = document.createElement("li");
    li.appendChild(a);
    ul.appendChild(li);
  }
  return ul;
}

function createStopple() {
  var header = document.createElement("h1");
  header.innerHTML = "Ой, какой старый браузер!";

  var p1 = document.createElement("p");
  p1.innerHTML = "Похоже, Вы используете один из тех браузеров, работу с которыми мы не поддерживаем.";

  var p2 = document.createElement("p");
  p2.innerHTML = "Ваш браузер: " + bowser.name + " v" + bowser.version;

  var p3 = document.createElement("p");
  p3.innerHTML = "Используйте один из следующих браузеров:";
  p3.appendChild(makeBrowsersList([
    ["Google Chrome", "https://www.google.com/chrome/"],
    ["FireFox", "https://www.mozilla.org/firefox"],
    ["Opera", "http://www.opera.com/"],
    ["Chromium", "https://www.chromium.org/"],
    ["Safari", "http://www.apple.com/ru/safari/"],
    ["Microsoft Edge", "https://www.microsoft.com/microsoft-edge"]
  ]));

  var p4 = document.createElement("p");
  p4.innerHTML = "Если по каким-то причинам у Вас нет возможности установить один из современных браузеров, Вы можете продолжить работу в этом. Однако, отображение интерфейсов в нем скорее всего будет некорректным.";
  p4.setAttribute("class", "suicide");

  var a = document.createElement("a");
  a.setAttribute("href", "javascript: window.doExecApp();");
  a.setAttribute("class", "suicide");
  a.innerHTML = "Я понимаю риски и хочу продолжить работу в этом браузере";

  var container = document.createElement("div");
  container.setAttribute("class", "bad-browser");
  container.setAttribute("id", STOPPLE_ID);
  container.appendChild(header);
  container.appendChild(p1);
  container.appendChild(p2);
  container.appendChild(p3);
  container.appendChild(p4);
  container.appendChild(a);
  document.getElementById("app").appendChild(container);
  document.body.style.background = "#ffffff";
}

function removeStopple() {
  var stopple = document.getElementById(STOPPLE_ID);
  if (stopple) {
    stopple.parentElement.removeChild(stopple);
  }
}
